import * as React from "react";
import {
  Button,
  ButtonGroup
} from "@blueprintjs/core";

import { withTranslation } from "react-i18next";
import { Trans } from "react-i18next";

class LogOutBtn extends React.Component {
  constructor() {
    super();
    this.state = {
      data: [],
      user: localStorage.getItem('user'),
    }
  }

  render() {
    if (this.state.redirect !== undefined) {
      window.location.replace(`/ow/view${this.state.redirect}`);
      return null;
    }

    if (localStorage.getItem('token')) {
      return (
        <ButtonGroup>
          <Button icon="log-out"
            onClick={() => {
              localStorage.clear();
              this.setState({ redirect: "/signin" });
            }}>
            {(window.innerWidth > 500) ? <div><Trans>logged as</Trans><b> {localStorage.getItem('user')}</b></div> : ""}

          </Button>

        </ButtonGroup>
      );
    } else {
      return (
        <ButtonGroup>
          <Button icon="log-in"
            onClick={() => {
              this.setState({ redirect: "/signin" });
            }}><Trans>log in</Trans></Button>

        </ButtonGroup>
      );
    }
  }
}

export default withTranslation()(LogOutBtn);